<template>
    <portal>
        <div class="mb-8 d-flex align-center">
            <v-icon color="primary" size="30">mdi-file-chart</v-icon>
            <h1 class="headline ml-4 font-weight-bold grey--text--darken-2 text-uppercase">Request a Report</h1>
        </div>
        <v-card class="pa-8">
            <v-card-title>Notification Settings</v-card-title>
            <v-row class="pa-4">
                <v-col cols="6">
                    <p>Email Notifications</p>
                </v-col>
                <v-col cols="6">
                    <v-checkbox v-model="emailReport.enabled" :label="'Receive reports via email'"></v-checkbox>
                </v-col>
            </v-row>
            <v-row class="pa-4">
                <v-col cols="6">
                    <p>Frequency</p>
                </v-col>
                <v-col cols="6">
                    <v-select
                        :items="frequencies"
                        item-text="name"
                        item-value="value"
                        v-model="emailReport.frequency"
                    ></v-select>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-btn name="commit"
                           class="d-flex mx-auto"
                           @click="saveEmailReport">Save</v-btn>
                </v-col>
            </v-row>
        </v-card>

        <v-card class="pa-8 mt-8">
            <v-card-title>Request a Report</v-card-title>
            <v-row v-if="reportLoading">
                <v-col>
                    <v-progress-circular
                        class="d-flex mx-auto"
                        indeterminate
                        color="primary"
                    >
                    </v-progress-circular>
                </v-col>
            </v-row>
            <v-row v-else>
                <v-col>
                    <v-btn name="commit" class="d-flex mx-auto" @click="processForm">Export</v-btn>
                </v-col>
            </v-row>
        </v-card>

    </portal>
</template>

<script>
import Portal from "@/components/Portal";
import {mapGetters} from "vuex";
import axios from "axios";
import Echo from "laravel-echo";

export default {
    name: "Reports",
    components: {
        Portal
    },
    computed: {
        ...mapGetters('auth', [
            'user',
        ]),
    },
    data() {
        return {
            checkedSubsections: [],
            emailReport: {
                enabled: false,
                frequency: 0,
            },
            reportLoading: false,
            frequencies: [
                {name: 'Daily', value: 0},
                {name: 'Weekly', value: 1},
                {name: 'Monthly', value: 2},
            ],
        }
    },
    mounted() {
        axios.get('/api/household/' + this.user.household_id + '/export-email-reports')
            .then(response => {
                this.emailReport = response.data.data.email_report;
            });

        window.io = require('socket.io-client');

        window.Echo = new Echo({
            broadcaster: 'socket.io',
            host: process.env.VUE_APP_ECHO_URL
        });

        window.Echo.channel('export-complete.' + this.user.household_id)
            .listen('.Household\\Events\\ExportCompleteEvent', (e) => {
                this.reportLoading = false;
                window.location = process.env.VUE_APP_BASE_URL + '/exports/' + e.id + '/download';
            });
    },
    methods: {
        saveEmailReport: function() {
            axios.post('/api/household/' + this.user.household_id + '/export-email-reports', {
                email_reports: this.emailReport.enabled,
                frequency: this.emailReport.frequency,
            }, { showLoader: false });
        },
        processForm: function() {
            axios.post('/api/household/' + this.user.household_id + '/client-accounts-reports')
                .then(() => {
                    this.reportLoading = true;
                });
        }
    }
}
</script>

<style scoped>

</style>
